import { ListItem, ListItemButton, ListItemText } from "@mui/material";

import { VisibilityToggle } from "@/shared/components/VisibilityToggle";
import { EventRecord } from "@/shared/domain/events";
import { actions } from "@/shared/state/visualization";
import { useVizDispatch } from "@/shared/state/visualization/hooks";

import { useEventVisibilityResolver } from "../../eventVisibility";
import { FilterMatch } from "../filterResult";
import { HighlightedText } from "../HighlightedText";

import styles from "./Event.module.css";

interface EventProps {
  event: EventRecord;
  match?: FilterMatch;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export function Event({ event, match, onClick }: EventProps) {
  // The row shows the event's resolved visibility, so an event the workspace
  // rule hides reads as off. Toggling writes an explicit per-event override,
  // which outranks the rule from then on.
  const isEventVisible = useEventVisibilityResolver();
  const isVisible = isEventVisible(event);

  const dispatch = useVizDispatch();

  return (
    <ListItem
      key={event.event_id}
      secondaryAction={
        <VisibilityToggle
          on={isVisible}
          className={styles.visibilityButton}
          onToggle={() => {
            dispatch(actions.setEventVisibility(event, !isVisible));
          }}
        />
      }
      sx={{
        "& .MuiListItemSecondaryAction-root": {
          right: "12px",
        },
      }}
      disablePadding
    >
      <ListItemButton onClick={onClick}>
        <ListItemText
          primary={<HighlightedText text={event.name} match={match} />}
          title={event.name}
          style={{
            opacity: isVisible ? 1 : 0.5,
          }}
          primaryTypographyProps={{
            className: styles.eventName,
          }}
        />
      </ListItemButton>
    </ListItem>
  );
}
